const entity = {
    create_failed: 'Falha ao criar {{name}}.',
    not_exists: '{{name}} não existe.',
    not_exists_with_id: '{{name}} com o ID `{{id}}` não existe.',
    not_found: 'O recurso não existe.',
};
export default entity;
